module.exports = __webpack_public_path__ + "static/media/anon-user.ae09b66c.png";